<template>
  <div class="form-container">
    <div v-if="loading" class="loading-overlay">
      <b-spinner
        label="Loading..."
        variant="primary"
        class="spinner"
      ></b-spinner>
    </div>
    <h2>{{ title }}</h2>

    <div class="form-group-custom">
      <label>
        Would you like your lending criteria to be automatically matched with
        flight schools and students?
      </label>
      <HiloSelect
        id="automaticallyMatched"
        :theme="'grey'"
        v-model="form.automaticallyMatched"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Choose one...'"
        :customStyle="{
          height: '50px',
          width: '100%',
          padding: '10px',
        }"
      />
    </div>

    <div class="form-group-custom">
      <label>
        Would you allow instant pre-qualifications based on Hilo’s data?
      </label>
      <HiloSelect
        id="allowInstantPreQualifications"
        :theme="'grey'"
        v-model="form.allowInstantPreQualifications"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Choose one...'"
        :customStyle="{
          height: '50px',
          width: '100%',
          padding: '10px',
        }"
      />
    </div>

    <!-- HIDING FOR NOW SINCE WE CAN'T DO TEXT YET   -->
    <!--    <div class="form-group-custom">-->
    <!--      <label> Preferred Notification Method </label>-->
    <!--      <HiloSelect-->
    <!--        :theme="'grey'"-->
    <!--        v-model="form.notificationMethod"-->
    <!--        :options="[{ id: 1, name: 'Email' },-->
    <!--            { id: 4, name: 'Text' }]"-->
    <!--        :placeholder="'Choose one...'"-->
    <!--        :customStyle="{-->
    <!--          height: '50px',-->
    <!--          width: '100%',-->
    <!--          padding: '10px',-->
    <!--        }"-->
    <!--      />-->
    <!--    </div>-->

    <div class="form-group-custom">
      <label> States/Regions where loans can be offered </label>
      <HiloSelect
        id="stateLoansOffered"
        multi-select
        :theme="'grey'"
        v-model="form.loanStates"
        :options="states"
        :placeholder="'Select all that apply...'"
        :customStyle="{
          height: '50px',
          width: '100%',
          padding: '10px',
        }"
      />
    </div>

    <div class="form-group-custom">
      <label for="maximum-no-of-schools"
        >Maximum number of students your willing to provide financing to?</label
      >
      <input
        type="number"
        id="maximum-no-of-schools"
        v-model="form.maximumNumberOfStudents"
        placeholder="Type your answer..."
      />
    </div>

    <div class="form-group-custom">
      <label for="annual-loan-volume"
        >Annual Loan Volume Target (e.g., $1,000,000, $10,000,000)</label
      >
      <input
        type="number"
        id="annual-loan-volume"
        v-model="form.annualLoanVolume"
        placeholder="Type your answer..."
      />
    </div>
    <div class="form-group-custom">
      <label
        >Hilo AI utilizes pre-approval systems to help students and lenders
        connect more efficiently. By clicking “I Agree” you agree to allow Hilo
        AI to provide pre-approval documentation on your behalf to students
        based on their credit score and other applicable data.</label
      >
      <div class="clickHereSubtext">
        <span><a>Click Here</a></span>
        <span> to view pre-approval policies and documentation.</span>
      </div>
    </div>

    <div class="form-group-custom">
      <div style="justify-content: space-evenly">
        <input
          type="checkbox"
          id="check"
          style="width: 20px"
          v-model="form.contractAgreement"
          required
        />
        <label for="check"> I agree </label>
      </div>
    </div>

    <label for="agreeTerms" style="flex: 1">
      <span>By creating an account, I agree to Hilo’s</span>
      <span class="privacyPolicy"> Privacy Policy </span>
      <span>and </span>
      <span class="privacyPolicy">Terms of Service.</span>
    </label>

    <div class="buttonContainer">
      <div class="nextButton" @click="handleNext">
        <b class="name">Finish</b>
      </div>
      <div class="backButton" @click="$emit('onPrev')">
        <b class="name">Back</b>
      </div>
    </div>
    <div v-if="showCongratsModal" class="congratsOverlay">
      <div class="congratsModal">
        <h2>🎉 Congratulations!</h2>
        <p>You’ve successfully completed the sign-up process.</p>
        <p>A Hilo administrator will reach out to you for onboarding.</p>
        <p>Once that’s complete, you’ll be able to log into the main app.</p>
        <button class="loginButton" @click="goToLoginPage">
          Go To Login Page
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
import AboutYouAPIService from "@/servicehandlers/AboutYouAPIService";
const aboutYouAPIService = new AboutYouAPIService();
import get from "lodash/get";

export default {
  components: {
    HiloSelect,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
    lenderId: {
      type: Number,
    },
  },
  data() {
    return {
      form: {
        automaticallyMatched: "",
        allowInstantPreQualifications: "",
        loanStates: [],
        maximumNumberOfStudents: "",
        annualLoanVolume: "",
        contractAgreement: "",
      },
      signatureModalVisible: false,
      states: [],
      loading: false,
      showCongratsModal: false,
    };
  },
  async mounted() {
    this.loading = true;
    try {
      await this.getStatesList();
      await this.getIntegrationsSavedData();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async getStatesList() {
      try {
        this.states = await aboutYouAPIService.getStateOptionsList();
      } catch (error) {}
    },
    async getIntegrationsSavedData() {
      if (this.lenderId) {
        try {
          const fetchedData = await aboutYouAPIService.getLenderById(
            this.lenderId,
          );
          if (fetchedData) {
            this.form = { ...this.form, ...fetchedData };
          }
        } catch (error) {}
      }
    },
    async handleNext() {
      let isValid = true;
      const validations = [
        { field: "automaticallyMatched", desc: "automatic matching" },
        {
          field: "allowInstantPreQualifications",
          desc: "instant pre-qualifications",
        },
        { field: "loanStates", desc: "valid loan states" },
        {
          field: "maximumNumberOfStudents",
          desc: "maximum number of students",
        },
        { field: "annualLoanVolume", desc: "annual loan volume" },
        { field: "contractAgreement" },
      ];

      for (const { field, desc } of validations) {
        const fieldValue = get(this.form, field);

        if (
          field !== "contractAgreement" &&
          (fieldValue === undefined ||
            fieldValue === null ||
            fieldValue === "" ||
            (Array.isArray(fieldValue) && fieldValue.length === 0))
        ) {
          isValid = false;
          alert(`Please enter a ${desc}`);
          break;
        }

        if (field === "contractAgreement" && !fieldValue) {
          isValid = false;
          alert(`Please check the box to agree to the policies.`);
          break;
        }
      }

      if (!isValid) return;
      try {
        this.loading = true;
        const integrationsData = {
          ...this.form,
          lenderId: this.lenderId,
          userId: this.userId,
          lenderStatusId: 4,
        };
        const lender =
          await aboutYouAPIService.createOrUpdateLender(integrationsData);
        if (!this.lenderId) {
          this.$emit("setLenderId", lender.id);
        }

        this.showCongratsModal = true;
        // V2
        // this.$emit("onNext", { integrations: this.form });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    goToLoginPage() {
      this.$router.push({ name: "Login" });
    },
  },
};
</script>
<style>
.privacyPolicy {
  color: #3c78ff;
}
.buttonContainer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.buttonContainer div {
  align-self: stretch;
  border-radius: 10px;
  height: 50px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
  transition: 0.2s ease-in-out;
}

.buttonContainer div:hover {
  opacity: 0.8;
}

.nextButton {
  background-color: #3c78ff;
}

.backButton {
  background-color: #ccc;
}

.upload-action span {
  font-size: 12px;
}

.description h3 {
  font-weight: bold;
}
.clickHereSubtext {
  font-size: 12px;
  color: grey;
  align-items: start;
}
a {
  color: dodgerblue;
}
a:hover {
  cursor: pointer;
}
.congratsOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.congratsModal {
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  text-align: center;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.loginButton {
  margin-top: 20px;
  padding: 10px 25px;
  background-color: #3c78ff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
}
</style>
